<div *ngIf="sessionCheckPending" class="login-session-check" role="status" aria-live="polite" aria-busy="true">
  <div class="login-session-check__spinner" aria-hidden="true"></div>
  <p class="login-session-check__text">Signing you in…</p>
</div>

<app-login-layout *ngIf="!sessionCheckPending">
  <app-login-form *ngIf="!alreadyLoggedIn"></app-login-form>
  <app-switch-account
    *ngIf="alreadyLoggedIn"
    [savedUsers]="savedUsers"
    (useAnotherAccount)="handleUseAnotherAccount()">
  </app-switch-account>
  <app-active-account-modal
    *ngIf="authService.showForceLoginModal()"
    (proceeded)="onProceed()"
    (cancelled)="onCancel()">
  </app-active-account-modal>
</app-login-layout>
